export type DateToReadableDateOptions = {
  date: string | Date;
  month?: boolean;
  day?: boolean;
  year?: boolean;
  hour?: boolean;
  minute?: boolean;
};

/** Format a Gregorian date for Persian UI display */
export function dateToReadableDate({
  date,
  month = false,
  day = false,
  year = false,
  hour = false,
  minute = false
}: DateToReadableDateOptions): string {
  const format: Intl.DateTimeFormatOptions = {};
  if (day) Object.assign(format, {day: 'numeric'});
  if (month) Object.assign(format, {month: 'long'});
  if (year) Object.assign(format, {year: 'numeric'});
  if (hour) Object.assign(format, {hour: 'numeric'});
  if (minute) Object.assign(format, {minute: 'numeric'});
  return new Date(date).toLocaleDateString('fa-IR', format);
}
